import levenshtein from "js-levenshtein";

const stripNonLetter = (t: string) =>
  t.replace(/[^a-zA-Z/-]+/, "").toLowerCase();

const eitherPhraseContainsTheOther = (first: string, second: string) => {
  const f = stripNonLetter(first);
  const s = stripNonLetter(second);
  return f.indexOf(s) !== -1 || s.indexOf(f) !== -1;
};

// TODO: Memoize
export const stringDistance = (first: string, second: string) => {
  if (eitherPhraseContainsTheOther(first, second)) {
    return 1;
  } else {
    return levenshtein(first, second);
  }
};
